import React, {useEffect, useMemo, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import './style.less';
import RichTextEditor from "../../../../../../../../../../../components/RichTextEditor";
import {useForm} from "react-hook-form";
import Buttons from "../../../../../components/Buttons";
import {propertyServices} from "../../../../../../../../../../../services"
import moment from "moment";
import {useAuth} from "../../../../../../../../../../../services/authServices";
import {updatePropertyActions} from "../../../../../../../../../../../redux/actions/updatePropertyActions";
import {connect} from "react-redux";
import {withReact} from "slate-react";
import {createEditor} from "slate";

const pageLabel = 'main_page.my_ads.create_ad.house_details.more_info';

const PropertyDetails5 = ({
                              updateProperty,
                              currentLevel,
                              property,
                              changePage,
                              defineUpdateFunc,
                              currentRoomNumber
                          }) => {

    const {t} = useTranslation();
    const {user} = useAuth();
    const [editorEn] = useState(() => withReact(createEditor()));
    const [editorPt] = useState(() => withReact(createEditor()));
    const [editorEs] = useState(() => withReact(createEditor()));
    const [editorIt] = useState(() => withReact(createEditor()));
    const editorRefEn = useRef(null);
    const editorRefPt = useRef(null);
    const editorRefEs = useRef(null);
    const editorRefIt = useRef(null);

    const originalValue = currentRoomNumber ? property.rooms["room_" + currentRoomNumber]?.moreInfo : property?.moreInfo;;

    const defaultValue = {
        "en": [{type: 'paragraph', children: [{text: "A line of text in a paragraph."}],}],
        "pt": [{type: 'paragraph', children: [{text: "Uma linha de texto num parágrafo."}],}],
        "es": [{type: 'paragraph', children: [{text: "Una línea de texto en un párrafo."}],}],
        "it": [{type: 'paragraph', children: [{text: "Una riga di testo in un paragrafo."}],}]
    };
    const emptyValue = [{type: "paragraph", children: [{text: ""}]}];

    const usedValue = useMemo(() => {
        if(originalValue) {
            return {
                "en": (originalValue["en"] && originalValue["en"].length > 0) ? originalValue["en"] : defaultValue["en"],
                "pt": (originalValue["pt"] && originalValue["pt"].length > 0) ? originalValue["pt"] : defaultValue["pt"],
                "es": (originalValue["es"] && originalValue["es"].length > 0) ? originalValue["es"] : defaultValue["es"],
                "it": (originalValue["it"] && originalValue["it"].length > 0) ? originalValue["it"] : defaultValue["it"],
            }
        } else {
            return defaultValue;
        }
    }, []);

    const onSubmit = async (values) => {
        if (editorRefEn.current) editorRefEn.current.blur();
        if (editorRefPt.current) editorRefPt.current.blur();
        if (editorRefEs.current) editorRefEs.current.blur();
        if (editorRefIt.current) editorRefIt.current.blur();

        if (values.moreInfo && JSON.stringify(values.moreInfo) !== JSON.stringify(defaultValue) && JSON.stringify(values.moreInfo) !== JSON.stringify(originalValue)) {
            if (currentRoomNumber) {
                await propertyServices.updateRoomDetails(values, property.id, "room_" + currentRoomNumber);
            } else {
                await updateProperty(values, currentLevel);
            }
        }
    }

    const {handleSubmit, control, register} = useForm({shouldFocusError: true});


    useEffect(() => {
        defineUpdateFunc(async () => new Promise(async (resolve) => {
            setTimeout(async () => {
                await handleSubmit(async () => {
                    let submitVal = {moreInfo: {}};
                    if ((editorEn.children.length >= 1 || !!editorEn.children[0].text) && editorEn.children !== defaultValue["en"]) submitVal.moreInfo["en"] = editorEn.children;
                    if ((editorPt.children.length >= 1 || !!editorPt.children[0].text) && editorPt.children !== defaultValue["pt"]) submitVal.moreInfo["pt"] = editorPt.children;
                    if ((editorEs.children.length >= 1 || !!editorEs.children[0].text) && editorEs.children !== defaultValue["es"]) submitVal.moreInfo["es"] = editorEs.children;
                    if ((editorIt.children.length >= 1 || !!editorIt.children[0].text) && editorIt.children !== defaultValue["it"]) submitVal.moreInfo["it"] = editorIt.children;
                    for (const lang of Object.keys(submitVal.moreInfo)) {
                        if (JSON.stringify(submitVal.moreInfo[lang]) === JSON.stringify(defaultValue[lang]) || JSON.stringify(submitVal.moreInfo[lang]) === JSON.stringify(emptyValue)) {
                            delete submitVal.moreInfo[lang];
                        }
                    }
                    if (Object.keys(submitVal.moreInfo).length === 0) {
                        submitVal.moreInfo = "$_REMOVE_$";
                    }
                    console.log("Submitting Property Details 5:", submitVal);
                    await onSubmit(submitVal);
                    resolve()
                }, resolve)()
            }, 0);
        }))
    }, []);

    return (<div className={"PropertyDetails5"}>
        <h6>{t(pageLabel + (".title"))}</h6>
        <small>{t(pageLabel + (".subtitle"))}</small>
        <form className={'PropertyDetails5'}>
            <RichTextEditor ref={editorRefEn} control={control} register={register} defaultValue={usedValue["en"]} editor={editorEn} lang={"en"}/>
            <RichTextEditor ref={editorRefPt} control={control} register={register} defaultValue={usedValue["pt"]} editor={editorPt} lang={"pt"}/>
            <RichTextEditor ref={editorRefEs} control={control} register={register} defaultValue={usedValue["es"]} editor={editorEs} lang={"es"}/>
            <RichTextEditor ref={editorRefIt} control={control} register={register} defaultValue={usedValue["it"]} editor={editorIt} lang={"it"}/>
            <Buttons changePage={changePage}/>
        </form>
    </div>);
};

const actionCreator = {
    defineUpdateFunc: updatePropertyActions.defineUpdateFunc
};

export default connect(null, actionCreator)(PropertyDetails5);
